import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, ENUM_MOD_NAME, stateEnum } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"
const { memoEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  memoParams: {},
  rptData: [],
  modSettingData: [],
  stockMemoData: [],
  mixMemoData: [],
  returnDetailParams: {},
  returnIsNewEntry: false,
}

export const setMemoDetail = createAsyncThunk(
  "memo/fetchMemoDetail",
  async ({ token, comp_code, trans_id, bill_type, trade_of, db_user }) => {
    try {
      const { data } = await customAPI.post(
        apiRoute.memoEntry.fetchMemoData,
        {
          compcode: comp_code,
          billtype: bill_type,
          tradeof: trade_of,
          transid: trans_id,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)

export const setModSettingData = createAsyncThunk(
  "memo/fetchModSettingDetail",
  async ({ token, mod_name, db_user }) => {
    try {

      const { data } = await customAPI.post(
        apiRoute.modSetting.getMultiModSetting,
        {
          page_mod: mod_name,
          master_mod: ENUM_MOD_NAME.GeneralSettings,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)


const memoEntrySlice = createSlice({
  name: memoEntry,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(setMemoDetail.fulfilled, (state, action) => {
        state.rptData = action.payload
      })
      .addCase(setMemoDetail.rejected, (state, action) => {
        state.rptData = []
      });
    builder
      .addCase(setModSettingData.fulfilled, (state, action) => {
        state.modSettingData = action.payload
      })
      .addCase(setModSettingData.rejected, (state, action) => {
        state.modSettingData = []
      });
  },
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    setMemoParams: (state, action) => {
      state.memoParams = action.payload
    },
    setStockMemoData: (state, action) => {
      state.stockMemoData = action.payload
    },
    setMixMemoData: (state, action) => {
      state.mixMemoData = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true
      state.stockMemoData = []
      state.mixMemoData = []
    },
    resetReportData: (state) => {
      state.rptData = []
      state.modSettingData = []
    },
    resetStockMemoData: (state) => {
      state.stockMemoData = []
    },
    resetMixMemoData: (state) => {
      state.mixMemoData = []
    },
    setReturnNewEntryMode: (state, action) => {
      state.returnIsNewEntry = action.payload
    },
    setReturnDetailParams: (state, action) => {
      state.returnDetailParams = action.payload
    },
     resetReturnDetailParams: (state) => {
      state.returnDetailParams = {}
      state.returnIsNewEntry = true
    },

  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode, setMemoParams, setStockMemoData, resetReportData, resetStockMemoData
  , setMixMemoData, resetMixMemoData, setReturnDetailParams, setReturnNewEntryMode,resetReturnDetailParams
} = memoEntrySlice.actions
export default memoEntrySlice.reducer
